import { useSelectedLink } from 'store/selectors'
import SelectedFriendship from './SelectedFriendship'

const SelectedLink = () => {
  const selectedLink = useSelectedLink()
  return !!selectedLink.friendship ? <SelectedFriendship /> : null
}

export default SelectedLink
